import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Account from "../views/Account.vue";
import Price from "../views/Price.vue";
import Staking from "../views/Staking.vue";
import LadderStaker from "../views/LadderStaker.vue";
import PenaltyView from "../views/PenaltyView.vue";
import Supply from "../views/Supply.vue";
import TopLists from "../views/TopLists.vue";
import News from "../views/News.vue";
import SiteTemplate from "../views/SiteTemplate.vue";
import Privacy from "../views/Privacy.vue";
import Disclaimer from "../views/Disclaimer.vue";
import NotFound from "../views/NotFound.vue";
import HowToGetWise from "../views/HowToGetWise.vue";
import HowToStakeWise from "../views/HowToStakeWise.vue";
import InsuranceStaking from "../views/InsuranceStaking.vue";
import FAQ from "../views/FAQ.vue";
import CommunitySites from "../views/CommunitySites.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Dashboard
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard
  },
  {
    path: "/account",
    name: "account",
    component: Account
  },
  {
    path: "/account/:address",
    name: "account",
    component: Account
  },
  {
    path: "/address/:address",
    name: "account",
    component: Account
  },
  {
    path: "/price",
    name: "price",
    component: Price
  },
  {
    path: "/staking",
    name: "staking",
    component: Staking
  },
  {
    path: "/ladderstaker",
    name: "ladderstaker",
    component: LadderStaker
  },
  {
    path: "/penalties",
    name: "penalties",
    component: PenaltyView
  },
  {
    path: "/supply",
    name: "supply",
    component: Supply
  },
  {
    path: "/toplists",
    name: "toplists",
    component: TopLists
  },
  {
    path: "/news",
    name: "news",
    component: News
  },
  {
    path: "/howtogetwise",
    name: "howtogetwise",
    component: HowToGetWise
  },
  {
    path: "/howtostakewise",
    name: "howtostakewise",
    component: HowToStakeWise
  },
  {
    path: "/insurancestaking",
    name: "insurancestaking",
    component: InsuranceStaking
  },
  {
    path: "/faq",
    name: "faq",
    component: FAQ
  },
  {
    path: "/community",
    name: "community",
    component: CommunitySites
  },
  {
    path: "/test",
    name: "test",
    component: SiteTemplate
  },
  {
    path: "/privacy",
    name: "privacy",
    component: Privacy,
  },
  {
    path: "/disclaimer",
    name: "disclaimer",
    component: Disclaimer,
  },
  {
    path: "*",
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
});

export default router;
